module.exports = __webpack_public_path__ + "img/hotel-red.53f19cb2.png";